var divider_viewer_rtlignore_default = {
  "divider-container": "HzISn",
  "divider-container--double": "KIV-p",
  "divider": "CYArJ",
  "divider--single": "gO6Bc",
  "divider--double": "K-HWj",
  "divider--dashed": "PQ1-E",
  "divider--dotted": "Uotie",
  "divider--small": "iPaFh",
  "divider--medium": "Qg428",
  "divider--large": "Rpbey",
  "divider--left": "WRxiZ",
  "divider--center": "ONnvb",
  "divider--right": "MjV72",
  "svgFixerContainer": "mYJTY",
  "emptyChar": "TTID-"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
